// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trigger-icon,
.menu-icon {
  display: inline-flex;
  width: 18px;
  height: 18px;
}
.trigger-icon { width: 20px; height: 20px; }

.trigger-icon svg,
.menu-icon svg { width: 100%; height: 100%; }

.avatar-icon {
  display: inline-flex;
  width: 14px;
  height: 14px;
  color: #fff;
}
.avatar-icon svg { width: 100%; height: 100%; }`, "",{"version":3,"sources":["webpack://./src/styles/Icons.css"],"names":[],"mappings":"AAAA;;EAEE,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;AACA,gBAAgB,WAAW,EAAE,YAAY,EAAE;;AAE3C;iBACiB,WAAW,EAAE,YAAY,EAAE;;AAE5C;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA,mBAAmB,WAAW,EAAE,YAAY,EAAE","sourcesContent":[".trigger-icon,\n.menu-icon {\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n}\n.trigger-icon { width: 20px; height: 20px; }\n\n.trigger-icon svg,\n.menu-icon svg { width: 100%; height: 100%; }\n\n.avatar-icon {\n  display: inline-flex;\n  width: 14px;\n  height: 14px;\n  color: #fff;\n}\n.avatar-icon svg { width: 100%; height: 100%; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
